import { render, staticRenderFns } from "./PlayerPage.vue?vue&type=template&id=472d2b5d&scoped=true&"
import script from "./PlayerPage.vue?vue&type=script&lang=js&"
export * from "./PlayerPage.vue?vue&type=script&lang=js&"
import style0 from "./PlayerPage.vue?vue&type=style&index=0&id=472d2b5d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "472d2b5d",
  null
  
)

export default component.exports